/**
 * @param {string} userAgent - User Agent string to evaluate;
 * @returns {string} browser name string input
 */
export default function (userAgent) {
  let browser;

  if (/Opera[\/\s](\d+\.\d+)/.test(userAgent)) {
    browser = "Opera";
  } else if (/MSIE (\d+\.\d+);/.test(userAgent)) {
    browser = "MSIE";
  } else if (/Navigator[\/\s](\d+\.\d+)/.test(userAgent)) {
    browser = "Netscape";
  } else if (/Chrome[\/\s](\d+\.\d+)/.test(userAgent)) {
    browser = "Chrome";
  } else if (/Safari[\/\s](\d+\.\d+)/.test(userAgent)) {
    browser = "Safari";
    /Version[\/\s](\d+\.\d+)/.test(userAgent);
  } else if (/Firefox[\/\s](\d+\.\d+)/.test(userAgent)) {
    browser = "Firefox";
  }

  return browser;
}
